import ImageComponent from '@sharedComponent/image-component';
import { Button, Col, Dropdown, Input, Menu, Select, DatePicker, Tooltip } from 'antd';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { images } from 'src/assets/img';
import selectors from '../selectors';
import Employeedetails from './employee-details-presentational';
import { connect } from 'react-redux';
import { withReducer } from 'src/store/reducerLoader';
import Actions from '../action.js';
import reducer from '../reducer.js';
import sagas from '../saga';
import moment from 'moment-timezone';
import Flatpickr from 'react-flatpickr';
import { useHistory } from 'react-router-dom';
import 'flatpickr/dist/themes/light.css';
import { Option } from 'antd/lib/mentions';
import * as uuid from 'uuid';
import './employeedetails.scss';

const Tablecomponent = ({
	postaddStart,
	getemployeeStart,
	getemployeeData,
	isGetEmployeeLoading,
	delemployeeStart,
	getnationalStart,
	getnationalData,
	employeeAdd,
	ordercardData,
	employeeData,
	getbanknameStart,
	getbanknameData,
	postapiStatus,
	getordercardStart,
}) => {
	const [searchInput, setSearchInput] = useState('');
	const [allselect, setallSelect] = useState(false);

	const [validate, setValidate] = useState([]);
	const [clearvalidate, setClearvalidate] = useState(false);
	const [check, setCheck] = useState(false);
	const [merge, setMerge] = useState([]);
	const [requestParams, setRequestParams] = useState({ pageNumber: 1, pageSize: 10 });
	const [dataSource, setDataSource] = useState([
		// {
		// 	key: uuid.v4(),
		// 	employeeName: '',
		// 	employeeId: '',
		// 	wpsPersonId: '',
		// 	wpsEstablishmentId: '',
		// 	labourCardNumber: '',
		// 	passportNumber: '',
		// 	dateOfBirth: '',
		// 	nationality: null,
		// 	salaryChannel: '',
		// 	ibanNumber: '',
		// 	bankName: '',
		// 	card: false,
		// },
	]);
	const [date, setDate] = useState([]);
	const [backupdataSource, setbackupDataSource] = useState([]);
	const location = useHistory();
	const head = location?.location?.state?.edit;
	const isAdd = head === 'add';

	useEffect(() => {
		getnationalStart();
		getbanknameStart();
	}, []);
	useEffect(() => {
		!isAdd && getemployeeStart(requestParams);
	}, [requestParams]);
	useEffect(() => {
		if (postapiStatus === 'success' && !employeeData?.validationMessage && !ordercardData.length > 0) {
			location.push({ pathname: './conclusionpage', state: { employee: {}, edit: 'ordercard' } });
		}
	}, [postapiStatus, validate, ordercardData]);

	useEffect(() => {
		if (isAdd) {
			setDataSource([]);
			setbackupDataSource([]);
			// setValidate([]);
		} else {
			if (getemployeeData.employeeStagings && getemployeeData.employeeStagings.length > 0) {
				let dataemp = getemployeeData.employeeStagings.map((val, index) => {
					return {
						...val,
						key: index,
					};
				});
				setDataSource(dataemp);
				setbackupDataSource(dataemp);
				setDate(dataemp);
			}
		}
	}, [getemployeeData]);

	useEffect(() => {
		!!!dataSource.length && handlerow();
	}, [dataSource]);
	useEffect(() => {
		// if (isAdd) {
		// 	// setValidate([]);
		// } else {
		setValidate(employeeData?.validationMessage || []);
		// }
	}, [employeeData]);

	const handlerow = () => {
		const newObj = {
			key: uuid.v4(),
			employeeName: '',
			employeeId: '',
			wpsPersonId: '',
			wpsEstablishmentId: '',
			labourCardNumber: '',
			passportNumber: '',
			dateOfBirth: '',
			nationality: null,
			salaryChannel: '',
			ibanNumber: '',
			bankName: null,
			card: false,
		};
		setDataSource([...dataSource, newObj]);
		setDate([...date, newObj]);
	};

	const handledelete = (row) => {
		row?.id && delemployeeStart(row.employeeId, requestParams);

		var value = merge.filter((data) => data?.key !== row.key);
		// const deletearray = value?.map((item, index) => {
		// 	return { ...item, key: index };
		// });
		setDataSource(value);
		setDate(value);
	};
	const handleselect = (row) => {
		var data = [...dataSource];
		const final = data?.map((val, index) => {
			if (val.key == row.key) {
				return { ...val, card: !val.card };
			} else {
				return val;
			}
			// return val;
		});
		setDataSource(final);
		const allselect = final?.filter((values) => values.card);
		if (allselect.length === dataSource.length) {
			setallSelect(true);
		} else {
			setallSelect(false);
		}
	};
	const newselect = useMemo(() => {
		const allselect = dataSource?.filter((values) => values?.card);
		if (allselect?.length === dataSource?.length) {
			setallSelect(true);
		} else {
			setallSelect(false);
		}
	}, [allselect, dataSource]);

	const handelallselect = () => {
		setallSelect(!allselect);
		var data = [...dataSource];
		const finaled = data?.map((val, index) => {
			if (!allselect) {
				return { ...val, card: true };
			} else {
				return { ...val, card: false };
			}
		});
		setDataSource(finaled);
	};

	const fieldInput = (param, row, data, validation) => {
		const isEmpty = Object.values(row).every((o) => o === '');
		let final = dataSource?.map((val) => {
			if (val?.key === row?.key) {
				return {
					...val,
					[param]: data,
				};
			}

			return val;
		});
		setDataSource(final);
		if (row?.employeeId !== '') {
			let error = validate?.map((val) => {
				if (val?.employeeId?.includes(row?.employeeId) && param?.toLowerCase() === val?.columnName?.toLowerCase()) {
					return {
						...val,
						errorMessage: '',
					};
				}
				return val;
			});

			setValidate(error);
		} else if (!isEmpty) {
			setValidate([]);
		}
	};

	const handleDate = (param, row, data) => {
		// const isEmpty = Object.values(row).every((o) => o === '');
		let final = date?.map((val) => {
			if (val?.key === row?.key) {
				return {
					...val,
					[param]: data,
				};
			} else {
				return val;
			}
		});
		setDate(final);
	};

	const options = {
		allowInput: true,
		dateFormat: 'd/m/Y',
		disableMobile: true,
		// minDate: 'today',
	};

	const handelPagiation = (paggination) => {
		const params = {
			pageNumber: paggination,
			pageSize: 10,
		};
		setRequestParams({
			pageNumber: paggination,
			pageSize: 10,
		});
		selectvalue(params, 'pagination');
	};

	const validationMsg = (validation, row, value) => {
		return validation && validation?.filter((data) => data?.employeeId?.includes(row?.employeeId) && data?.columnName === value);
	};
	const columns = [
		{
			sortDirections: ['ascend'],
			align: 'left',
			title: (
				<Col>
					<ImageComponent
						className="run-payroll-header-check"
						src={allselect ? images.Error : images.checkbox}
						onClick={() => handelallselect(allselect)}
						style={{ cursor: 'pointer', height: '28px' }}
					/>
				</Col>
			),
			dataIndex: 'isSelected',
			width: 50,
			render: (isSelected, row) => {
				return (
					<Col>
						<ImageComponent
							src={row?.card ? images?.tickcheck : images?.checkbox}
							onClick={() => handleselect(row)}
							style={{ cursor: 'pointer' }}
						/>
					</Col>
				);
			},
		},

		{
			title: 'Name',
			dataIndex: 'employeeName',
			key: 'employeeName',
			render: (isSelected, row) => {
				const ErrorMsg = validationMsg(validate, row, 'EmployeeName')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;

				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg} style={{ borderRadius: '8px' }}>
							<Input
								placeholder="Employee name"
								value={row?.employeeName}
								className={ErrorMsg ? 'errorMsgBorder' : ''}
								style={{ borderRadius: '8px' }}
								onChange={(e) => fieldInput('employeeName', row, e.target.value)}
								// onBlur={() => check(row, 'employeeName')}
							/>
						</Component>
					</Col>
				);
			},
			sorter: {
				compare: (a, b) => {
					return a.employeeName - b.employeeName;
				},
			},
		},
		{
			title: 'Employee ID',
			dataIndex: 'employeeId',
			key: 'employeeId',
			render: (isSelected, row) => {
				const ErrorMsg = validationMsg(validate, row, 'EmployeeId')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg}>
							<Input
								placeholder="Employee ID"
								className={ErrorMsg ? 'errorMsgBorder' : ''}
								style={{ borderRadius: '8px' }}
								value={row?.employeeId}
								onChange={(e) => fieldInput('employeeId', row, e.target.value)}
								// onBlur={() => check(row, 'employeeId')}
							/>
						</Component>
					</Col>
				);
			},
			sorter: {
				compare: (a, b) => {
					return a?.employeeId - b?.employeeId;
				},
			},
		},
		{
			title: 'WPS Person ID',
			dataIndex: 'wpsPersonId',
			key: 'wpsPersonId',
			render: (isSelected, row) => {
				const ErrorMsg = validationMsg(validate, row, 'WPSPersonId')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg}>
							<Input
								maxLength={14}
								className={ErrorMsg ? 'errorMsgBorder' : ''}
								placeholder="WPS Person ID"
								style={{ borderRadius: '8px' }}
								value={row?.wpsPersonId}
								onChange={(e) => fieldInput('wpsPersonId', row, e.target.value)}
							/>
						</Component>
					</Col>
				);
			},
			sorter: {
				compare: (a, b) => {
					return a?.wpsPersonId - b?.wpsPersonId;
				},
			},
		},
		{
			title: 'Establishment ID',
			dataIndex: 'wpsEstablishmentId',
			key: 'wpsEstablishmentId',
			render: (isSelected, row) => {
				const ErrorMsg = validationMsg(validate, row, 'WpsEstablishmentId')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg}>
							<Input
								className={ErrorMsg ? 'errorMsgBorder' : ''}
								maxLength={13}
								placeholder="Establishment ID"
								value={row?.wpsEstablishmentId}
								style={{ borderRadius: '8px' }}
								onChange={(e) => fieldInput('wpsEstablishmentId', row, e.target.value)}
								// onBlur={() => check(row, 'wpsEstablishmentId')}
							/>
						</Component>
					</Col>
				);
			},
			sorter: {
				compare: (a, b) => {
					return a?.wpsEstablishmentId - b?.wpsEstablishmentId;
				},
			},
		},
		{
			title: 'Labour Card',
			dataIndex: 'labourCardNumber',
			key: 'labourCardNumber',
			render: (isSelected, row) => {
				const ErrorMsg = validationMsg(validate, row, 'LabourCardNumber')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg}>
							<Input
								maxLength={8}
								className={ErrorMsg ? 'errorMsgBorder' : ''}
								placeholder="Labour Card "
								style={{ borderRadius: '8px' }}
								value={row?.labourCardNumber}
								onChange={(e) => fieldInput('labourCardNumber', row, e.target.value)}
								// onBlur={() => check(row, 'labourCardNo')}
							/>
						</Component>
					</Col>
				);
			},
			sorter: {
				compare: (a, b) => {
					return a?.labourCardNumber - b?.labourCardNumber;
				},
			},
		},
		{
			title: 'Passport',
			dataIndex: 'passportNumber',
			key: 'passportNumber',
			render: (isSelected, row) => {
				const ErrorMsg = validationMsg(validate, row, 'PassportNumber')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg}>
							<Input
								maxLength={12}
								placeholder="Passport "
								required={true}
								className={`red-star ${ErrorMsg ? 'errorMsgBorder' : ''}`}
								style={{ borderRadius: '8px' }}
								value={row?.passportNumber}
								onChange={(e) => fieldInput('passportNumber', row, e.target.value)}
							/>
						</Component>
					</Col>
				);
			},

			sorter: {
				compare: (a, b) => {
					return a?.passportNumber - b?.passportNumber;
				},
			},
		},
		{
			title: 'Iban Number',
			dataIndex: 'ibanNumber',
			key: 'ibanNumber',
			render: (isSelected, row) => {
				const ErrorMsg = validationMsg(validate, row, 'IbanNumber')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg}>
							<Input
								className={ErrorMsg ? 'errorMsgBorder' : ''}
								disabled={row?.card}
								maxLength={23}
								placeholder="Iban Number"
								style={{ borderRadius: '8px' }}
								value={row?.card ? '' : row?.ibanNumber}
								onChange={(e) => fieldInput('ibanNumber', row, e.target.value)}
								// onBlur={() => check(row, 'passportNumber')}
							/>
						</Component>
					</Col>
				);
			},

			sorter: {
				compare: (a, b) => {
					return a?.ibanNumber - b?.ibanNumber;
				},
			},
		},
		{
			title: 'BankName',
			dataIndex: 'bankName',
			key: 'bankName',
			render: (isSelected, row) => {
				let ban = row?.bankName ? row?.bankName : '';
				const ErrorMsg = validationMsg(validate, row, 'BankName')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg}>
							<Select
								className={ErrorMsg ? 'errorMsgBorder' : ''}
								disabled={row?.card}
								value={row?.card ? '' : row?.bankName}
								placeholder="BankName"
								style={{ borderRadius: '8px', width: '100%' }}
								onChange={(value) => fieldInput('bankName', row, value)}>
								{getbanknameData?.routingList?.map((e) => (
									<Option value={e?.bankName}>{e?.bankName}</Option>
								))}
							</Select>
						</Component>
					</Col>
				);
			},
			sorter: {
				compare: (a, b) => {
					return a?.bankName - b?.bankName;
				},
			},
		},
		{
			title: 'Nationality',
			dataIndex: 'nationality',
			key: 'nationality',
			render: (isSelected, row) => {
				const ErrorMsg = validationMsg(validate, row, 'Nationality')?.[0]?.errorMessage;

				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<Col>
						<Component placement="topLeft" title={ErrorMsg}>
							<Select
								value={row?.nationality}
								className={ErrorMsg ? 'errorMsgBorder' : ''}
								placeholder="Nationality"
								required={true}
								style={{ borderRadius: '8px', width: '100%' }}
								onChange={(value) => fieldInput('nationality', row, value)}>
								{getnationalData?.contries?.map((e) => (
									<Option value={e?.countryCode}>{e?.countryName}</Option>
								))}
							</Select>
						</Component>
					</Col>
				);
			},
			sorter: {
				compare: (a, b) => {
					return a?.Nationality - b?.Nationality;
				},
			},
		},
		{
			title: 'Date of Birth',
			dataIndex: 'dateOfBirth',
			key: 'dateOfBirth   ',
			sorter: {
				compare: (a, b) => {
					return a?.dateOfBirth - b?.dateOfBirth;
				},
			},
			render: (isSelected, row, index) => {
				const ErrorMsg = validationMsg(validate, row, 'DOB')?.[0]?.errorMessage;
				const Component = ErrorMsg ? Tooltip : Fragment;
				return (
					<>
						<Col style={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
							<Component placement="topLeft" title={ErrorMsg}>
								<Flatpickr
									placeholder={'DD / MM / YYYY'}
									required={true}
									className={ErrorMsg ? 'errorMsgBorder' : ''}
									style={{
										borderRadius: '8px',
										width: '100%',
										border: '1px solid #EFF1F5',
										height: '30px',
										outlineColor: '#1890ff',
										padding: '0px 4px',
									}}
									onChange={(data, value) => {
										handleDate('dateOfBirth', row, moment(value, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss'));
									}}
									value={moment(row?.dateOfBirth).format('DD/MM/YYYY')}
									{...{ options }}
								/>
							</Component>
							<ImageComponent src={images.deleteicon} onClick={() => handledelete(row)} />
						</Col>
					</>
				);
			},
		},
	];
	const datamerge = useMemo(() => {
		// const head = date ? date[index].dateOfBirth : '';
		let mergevalue = dataSource.map((val, index) => {
			if (val?.key === date[index]?.key) {
				return {
					...val,
					dateOfBirth: date[index].dateOfBirth === 'Invalid date' ? '' : date[index].dateOfBirth,
				};
			} else {
				return {
					...val,
					dateOfBirth:
						moment(val?.dateOfBirth).format('YYYY-MM-DDTHH:mm:ss') === 'Invalid date'
							? ''
							: moment(val?.dateOfBirth).format('YYYY-MM-DDTHH:mm:ss'),
				};
			}
		});
		setMerge(mergevalue);
	}, [dataSource, date]);

	const selectvalue = (params = null, type) => {
		let tempDataSource = dataSource.map((val, index) => {
			if (val?.key === date[index]?.key) {
				return {
					...val,
					dateOfBirth: date[index].dateOfBirth,
				};
			} else {
				return {
					...val,
					dateOfBirth: moment(val?.dateOfBirth).format('YYYY-MM-DDTHH:mm:ss'),
				};
			}
		});
		setDataSource(tempDataSource);
		const finalArray = tempDataSource?.filter((modifiedData) => {
			const apiData = backupdataSource?.find((aData) => aData.key === modifiedData.key);
			if (JSON.stringify(apiData) !== JSON.stringify(modifiedData)) return modifiedData;
		});
		console.log(finalArray, 'wthkey');
		const final = finalArray.map((val, index) => {
			return {
				...val,
				wpsPersonId: val?.wpsPersonId || '',
				labourCardNumber: val?.labourCardNumber || '',
				dateOfBirth: val?.dateOfBirth || '',
				card: val?.card || false,
				bankName: val.card ? '' : val?.bankName,
				ibanNumber: val.card ? '' : val.ibanNumber,
			};
		});

		postaddStart(final, params || requestParams, isAdd, type);
	};

	const buttoncheck = dataSource?.filter((item) => item?.card);
	const errorvalidation = useMemo(() => {
		merge.map((button) => {
			if (button?.employeeName && button?.employeeId && button?.passportNumber && button?.nationality && button?.dateOfBirth) {
				setClearvalidate(true);
			} else {
				setClearvalidate(false);
			}
		});
	}, [merge]);

	const filteredData = useMemo(() => {
		if (searchInput === '') {
			return dataSource;
		}

		return dataSource?.filter((item) => {
			return (
				(item?.employeeName || '')?.toLowerCase().includes(searchInput?.toLowerCase()) ||
				(item?.employeeId || '')?.toLowerCase().includes(searchInput?.toLowerCase())
			);
		});
	}, [dataSource, searchInput]);

	// const memoizedResult = useMemo(() => {
	// 	return JSON.stringify(backupdataSource) === JSON.stringify(finaldata);
	// }, [backupdataSource])
	return (
		<div>
			<Employeedetails
				loading={isGetEmployeeLoading}
				{...{
					searchInput,
					setSearchInput,
					filteredData,
					isAdd,
					requestParams,
					getemployeeData,
					handelPagiation,
					head,
					selectvalue,
					buttoncheck,
					handlerow,
					columns,
					setDataSource,
					dataSource,
					validate,
					clearvalidate,
					check,
					ordercardData,
				}}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		employeeAdd: selectors.employeeAdd(state),
		isEmployeeAdd: selectors.isEmployeeAdd(state),
		getemployeeData: selectors.getemployeeData(state),
		isGetEmployeeLoading: selectors.isGetEmployeeLoading(state),
		getnationalData: selectors.getnationalData(state),
		isNationalLoading: selectors.isNationalLoading(state),
		delemployeeData: selectors.delemployeeData(state),
		isDelEmployeeLoading: selectors.isDelEmployeeLoading(state),
		employeeData: selectors.employeeData(state),
		getbanknameData: selectors.getbanknameData(state),
		isBankNameLoading: selectors.isBankNameLoading(state),
		postapiStatus: selectors.postapiStatus(state),
		ordercardData: selectors.ordercardData(state),
		isOrderCardLoading: selectors.isOrderCardLoading(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		postaddStart: (params, requestParams, isAdd, etype) => dispatch(Actions.creators.postaddStart(params, requestParams, isAdd, etype)),
		getemployeeStart: (requestParams) => dispatch(Actions.creators.getemployeeStart(requestParams)),
		delemployeeStart: (params, requestParams) => dispatch(Actions.creators.delemployeeStart(params, requestParams)),
		getnationalStart: () => dispatch(Actions.creators.getnationalStart()),
		getbanknameStart: () => dispatch(Actions.creators.getbanknameStart()),
		getordercardStart: () => dispatch(Actions.creators.getordercardStart()),
	};
};

const Connection = connect(mapStateToProps, mapDispatchToProps)(Tablecomponent);

const ReducedScreen = withReducer('employeeReducer', reducer, sagas)(Connection);

export default ReducedScreen;
